<template>
  <div class="container">
    <div class="band-bankcard-box">
      <h3 class="title">{{ getBankInfo ? "修改" : "填写" }}银行卡信息</h3>
      <p class="tip">为确保提现安全，请务必绑定您本人的银行卡</p>
      <div class="input-box">
        <div class="input-item">
          <div class="label">真实姓名</div>
          <input
            type="text"
            v-model="realName"
            maxlength="10"
            placeholder="请输入本人真实姓名"
            @input="changeRealName"
          />
        </div>
        <div class="input-item">
          <div class="label">身份证号码</div>
          <input
            type="text"
            v-model="identityCardNumber"
            maxlength="18"
            placeholder="请输入本人身份证号码"
            @input="idCardInputHandler"
          />
        </div>
        <div class="input-item">
          <div class="label">银行卡号</div>
          <input
            type="text"
            v-model="bankcardNumber"
            placeholder="请输入本人银行卡号"
            @input="cardKeyup"
          />
        </div>
        <div class="input-item" v-if="hadGetBankInfo && bankInfo">
          <span>所属银行</span>
          <div class="bank">
            <img v-if="bankInfo.Logo" :src="bankInfo.Logo" alt="" />
            {{ bankInfo.BankName || "无" }}
          </div>
        </div>
      </div>
      <!-- button -->
      <div class="bottom-btn">
        <mt-button type="primary" @click="submit">{{
          hadGetBankInfo ? "确认提交" : "提交"
        }}</mt-button>
      </div>
    </div>
    <div class="yourBankCardList" v-if="getBankInfo">
      <div class="bankCardItem">
        <div class="leftPart">
          <span class="iconfont icon-ka"></span>
          <div class="cardInfo">
            <div class="cardName">当前银行卡</div>
            <div class="cardDetails oneRow">
              {{ getBankInfo.BankName }}：**** **** **** {{ getBankInfo.BankCardNumber.substr(-4) }}
            </div>
          </div>
        </div>
        <div class="unboundBtn tapActive" @click="showUnboundDialog = true">
          解绑
        </div>
      </div>
    </div>
    <template v-if="getBankInfo">
      <van-dialog
        v-model="showUnboundDialog"
        overlayClass="overlayClass"
        show-cancel-button
        cancelButtonText="暂不解绑"
        confirmButtonText="立即解绑"
        @confirm="immediatelyUnbound"
      >
        <div class="unboundDialogDetail">
          <div class="title">提示</div>
          <div class="subTitle">是否确认解绑当前银行卡？</div>
          <div class="subList">
            <div class="item">
              <div class="subLeft">
                <div class="dot"></div>
                <span>银行卡号:</span>
              </div>
              <div class="subRight">**** **** **** {{ getBankInfo.BankCardNumber.substr(-4) }}</div>
            </div>
            <div class="item">
              <div class="subLeft">
                <div class="dot"></div>
                <span>所属银行:</span>
              </div>
              <div class="subRight">{{ getBankInfo.BankName }}</div>
            </div>
          </div>
        </div>
      </van-dialog>
    </template>
  </div>
</template>

<script>
import { Indicator, Toast } from "mint-ui";
import {
  GetBankCardInfo,
  SubmitBankCardInfo,
  DeleteBankCardInfo,
} from "@/api/my";
import "../balanceWithdraw/children/iconfont";
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      realName: "",
      bankcardNumber: "",
      isLoading: false,
      hadGetBankInfo: false, // 是否已经获取过银行卡信息
      bankInfo: null,
      showUnboundDialog: false,
      identityCardNumber: "" , // 身份证号码
      IsOnlyIdentityCardNumber: false, // 只修改身份证号码
      realNameAndBankcardNumberUnNeedCheck: false, // 真实姓名和银行卡号码不需要校验
      identityCardNumberUnNeedCheck: false, // 身份证号码不需要校验
    };
  },
  methods: {
    ...mapMutations(["SET_BANK_INFO"]),
    // 银行卡信息获取
    fetchBankInfo() {
      Indicator.open({
        text: "加载中",
        spinnerType: "triple-bounce",
      });
      this.isLoading = true;
      GetBankCardInfo({
        realName: this.realName,
        bankCardNumber: this.bankcardNumber,
      })
        .then((res) => {
          this.isLoading = false;
          this.hadGetBankInfo = true;
          this.bankInfo = res;
          Indicator.close();
        })
        .catch((err) => {
          Indicator.close();
          this.isLoading = false;
          Toast(err.ErrMsg);
        });
    },
    // 银行卡提交
    fetchSubmit() {
      if (!this.bankInfo) return;
      Indicator.open({
        text: "加载中",
        spinnerType: "triple-bounce",
      });
      this.isLoading = true;
      let postData = {}
      if (this.IsOnlyIdentityCardNumber) {
        postData = {
          IdentityCardNumber: this.identityCardNumber,
          IsOnlyIdentityCardNumber: this.IsOnlyIdentityCardNumber
        }
      } else {
        postData = {
          RealName: this.bankInfo.RealName,
          BankName: this.bankInfo.BankName,
          Logo: this.bankInfo.Logo,
          CardType: this.bankInfo.CardType,
          BankCardNumber: this.bankInfo.BankCardNumber,
          IdentityCardNumber: this.identityCardNumber,
          IsOnlyIdentityCardNumber: this.IsOnlyIdentityCardNumber
        };
      }
      SubmitBankCardInfo(postData)
        .then((res) => {
          Indicator.close();
          this.isLoading = false;
          Toast("绑定成功");
          setTimeout(() => {
            this.$router.replace({
              name: "balanceWithdraw",
              params: {
                expectChoseWithdrawType: 2,
              },
            });
            this.$router.go(-1);
          }, 2000);
        })
        .catch((err) => {
          Indicator.close();
          this.isLoading = false;
          Toast(err.ErrMsg);
        });
    },
    cardChange() {
      if (this.bankcardNumber) {
        this.hadGetBankInfo = false;
        this.bankInfo = null;
      }
    },
    resetData() {
      this.realNameAndBankcardNumberUnNeedCheck = false
      this.IsOnlyIdentityCardNumber = false
      this.realName = ''
      this.bankcardNumber = ''
      this.identityCardNumber = ''
      this.bankInfo = null
      this.hadGetBankInfo = false
    },
    changeRealName() {
      if (this.realNameAndBankcardNumberUnNeedCheck) {
        if (this.realName !== this.getBankInfo.RealName) {
          this.resetData()
        }
      }
    },
    cardKeyup() {
      if (this.realNameAndBankcardNumberUnNeedCheck) {
        if (this.bankcardNumber !== this.getBankInfo.BankCardNumber) {
          this.resetData()
        }
        return
      }
      this.bankcardNumber = this.bankcardNumber.replace(/\D*/, "");
      if (this.bankcardNumber.length > 22)
        this.bankcardNumber = this.bankcardNumber.substring(0, 22);
    },
    idCardInputHandler() {
      if (this.identityCardNumberUnNeedCheck) {
        if (this.identityCardNumber !== this.getBankInfo.IdentityCardNumber) {
          this.identityCardNumberUnNeedCheck = false
          this.identityCardNumber = ''
        }
        return
      } 
      const regRules1 = /^0+/g; // 不能以0开头
      const regRules2 = /[^0-9]\d*/g; // 不能是小数
      const regRules3 = /[^\dX]$/g; // 最后一位只能是数字或者X
      setTimeout(() => {
        if (this.identityCardNumber.length <= 17) {
          this.identityCardNumber = this.identityCardNumber
          .replace(regRules1, "")
          .replace(regRules2, "");
        } else {
          this.identityCardNumber = this.identityCardNumber
          .replace(regRules3, "")
        }
      }, 0);
    },
    submit() {
      if (this.isLoading) return;
      let regRules1 = /^[\d]{17}[\dX]$/g
      if (this.IsOnlyIdentityCardNumber) {
        let {IdentityCardNumber} = this.getBankInfo
        if (IdentityCardNumber && (this.identityCardNumber === IdentityCardNumber)) {
          Toast('当前未修改，无需保存')
          return
        }
        if (!regRules1.test(this.identityCardNumber)) {
          Toast('请输入正确格式的身份证号码；若最后一位为字母X，请输入大写字母X')
          regRules1.lastIndex = 0
          return
        }
        this.fetchSubmit();
        return
      }
      if (!this.realName) return void Toast("请输入真实姓名");
      if (!this.identityCardNumber) return void Toast("请输入身份证号码");
      if (!regRules1.test(this.identityCardNumber)) {
        Toast('请输入正确格式的身份证号码；若最后一位为字母X，请输入大写字母X')
        regRules1.lastIndex = 0
        return
      }
      if (!this.bankcardNumber) return void Toast("请输入银行卡号");      
      if (this.bankcardNumber.length < 16 || this.bankcardNumber.length > 22) {
        Toast("银行卡号不正确，请重新输入");
        return;
      }
      if (this.hadGetBankInfo && this.bankInfo) {
        // 已经获取到银行卡信息
        this.fetchSubmit();
      } else {
        this.fetchBankInfo();
      }
    },
    // 立即解绑
    immediatelyUnbound() {
      Indicator.open({
        text: "加载中",
        spinnerType: "triple-bounce",
      });
      DeleteBankCardInfo()
        .then((res) => {
          Indicator.close();
          this.isLoading = false;
          this.$toast.success("解绑成功");
          this.$router.replace({
            name: "balanceWithdraw",
            params: {
              expectChoseWithdrawType: 2,
            },
          });
          this.$router.go(-1);
        })
        .catch((err) => {
          Indicator.close();
          Toast(err.ErrMsg);
        });
    },
  },
  computed: {
    ...mapGetters([
      "getBankInfo"
    ]),
    bankLogo() {
      let bankName = this.bankInfo.BankName;
      if (!bankName) return null;
      // 只适配以下银行的logo，其它银行使用接口返回的logo图片（ps：接口返回的logo片太丑）
      let reg = new RegExp(
        "中国银行|北京银行|交通银行|兴业银行|光大银行|深圳发展银行|浦东银行|中国邮政|广东发展银行|中国农业银行|华夏银行|中国民生银行|招商银行|工商银行|建设银行",
        "g"
      );
      let name = bankName.match(reg)[0];
      switch (name) {
        case "中国银行":
          return "#icon-zhongguoyinhang";
        case "北京银行":
          return "#icon-beijingyinhang";
        case "交通银行":
          return "#icon-Oval";
        case "兴业银行":
          return "#icon-xingyeyinhang";
        case "光大银行":
          return "#icon-guangdayinhang";
        case "深圳发展银行":
          return "#icon-shenzhenfazhanyinhang";
        case "浦东银行":
          return "#icon-pudongyinhang-";
        case "中国邮政":
          return "#icon-juxing";
        case "广东发展银行":
          return "#icon-guangdongfazhanyinhang";
        case "中国农业银行":
          return "#icon-nongyeyinhang";
        case "华夏银行":
          return "#icon-huaxiayinhang";
        case "中国民生银行":
          return "#icon-minshengyinhang";
        case "招商银行":
          return "#icon-zhaoshangyinhang";
        case "工商银行":
          return "#icon-gongshangyinhang";
        case "建设银行":
          return "#icon-jiansheyinhang";
        default:
          return null;
      }
    },
  },
  watch: {
    getBankInfo: {
      //立即监听
      immediate:true,
      handler(val) {
        if (val) {
          this.IsOnlyIdentityCardNumber = true
          this.realNameAndBankcardNumberUnNeedCheck = true          
          let {RealName, IdentityCardNumber, BankCardNumber} = val
          this.realName = RealName
          this.bankInfo = val
          this.hadGetBankInfo = true
          if (IdentityCardNumber) {
            this.identityCardNumber = IdentityCardNumber
            this.identityCardNumberUnNeedCheck = true
          }
          this.bankcardNumber = BankCardNumber
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.SET_BANK_INFO(null)
    next();
  },
};
</script>

<style scoped lang="scss">
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.container {
  background-color: #f2f2f2;
}
.band-bankcard-box {
  background: #ffffff;
  padding: 22vw 0 8vw;
}
.band-bankcard-box .title {
  font-size: 20px;
  text-align: center;
}
.band-bankcard-box .tip {
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
}
.input-box {
  margin: 15vw auto 0;
  width: 85%;
  font-size: 15px;
}
.input-box .input-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 14vw;
  border-top: 1px solid #e8e8e8;
  .label {
    flex-shrink: 0;
  }
}
.input-box .input-item:last-child {
  border-bottom: 1px solid #e8e8e8;
}
.input-item .bank {
  display: flex;
  align-items: center;
}
.input-item .bank img {
  display: block;
  width: 25px;
  height: 25px;
  margin-right: 5px;
}
.input-item .svg-icon {
  width: 22px;
  height: 22px;
  fill: currentColor;
  overflow: hidden;
  margin-right: 5px;
}
.input-box input {
  font-size: 16px;
  line-height: 14vw;
  text-align: right;
  min-width: 50vw;
}
.bottom-btn {
  margin: 30vw auto 0;
  width: 60%;
}
.bottom-btn .mint-button {
  width: 100%;
  font-size: 14px;
}
.yourBankCardList {
  .bankCardItem {
    display: flex;
    align-items: center;
    width: 95%;
    height: vw(80);
    background-color: #fff;
    margin: vw(20) auto 0;
    border-radius: vw(8);
    padding: vw(16) vw(14);
    box-sizing: border-box;
    .leftPart {
      display: flex;
      align-items: center;
      flex: 1;
      height: 100%;
      .iconfont {
        font-size: vw(24);
        margin-right: vw(14);
      }
      .cardInfo {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .cardName {
          color: #000;
          font-size: vw(15);
        }
        .cardDetails {
          color: #898989;
          font-size: vw(14);
        }
      }
    }
    .unboundBtn {
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 0 vw(14);
      height: vw(24);
      color: #26a2ff;
      border: 1px solid #26a2ff;
      border-radius: vw(12);
    }
  }
}
.unboundDialogDetail {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 20px 26px;
  .title {
    color: #1d1d1d;
    font-size: 18px;
    text-align: center;
    margin-bottom: 20px;
    font-weight: 500;
  }
  .subTitle {
    margin-bottom: 20px;
  }
  .subList {
    .item {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      color: #666666;
      &:last-child {
        margin-bottom: 0;
      }
      &.active {
        .subLeft {
          .dot {
            background-color: #f22c6c;
          }
        }
        .subRight {
          color: #f22c6c;
        }
      }
      .subLeft {
        display: flex;
        align-items: center;
        margin-right: 8px;
        .dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          margin-right: 8px;
          background-color: #9a9a9a;
        }
      }
    }
  }
}
</style>
